import { useState } from "react";

export function SmartImg({
  src,
  alt,
  fallback,
  className,
  style,
}: {
  src: string;
  alt: string;
  fallback: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  const [error, setError] = useState(false);
  if (error) {
    return (
      <div className={className} style={style}>
        {fallback}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      onError={() => setError(true)}
      className={className}
      style={style}
      draggable={false}
    />
  );
}
